import React from "react";
import CategoryForm from "./CategoryForm";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

const CreateCategory = () => (
  <DashboardLayout>
    <DashboardNavbar />
    <CategoryForm />
  </DashboardLayout>
);

export default CreateCategory;
